// extracted by mini-css-extract-plugin
module.exports = {"support":"Support_support__37Bsr","button":"Support_button__1CmLo"};